import {Enum, LocalizedEnum} from "../../common/enum/enum";

/**
 * Sector aggregators
 * @extends LocalizedEnum
 * @hideconstructor
 */
class EDIDSystemAggregatorEnum extends LocalizedEnum {
    static AGRICULTURE = new EDIDSystemAggregatorEnum(1, 'edid.enum.sectorAgg.agriculture','#CCC7F0');
    static ECOSYSTEMS = new EDIDSystemAggregatorEnum(2, 'edid.enum.sectorAgg.ecosystems','#44AA99');
    static ENERGY = new EDIDSystemAggregatorEnum(3, 'edid.enum.sectorAgg.energy','#CC6677');
    static INLAND_NAVIGATION = new EDIDSystemAggregatorEnum(4, 'edid.enum.sectorAgg.inlandNavigation','#DDCC77');
    static PUBLIC_WATER_SUPPLY = new EDIDSystemAggregatorEnum(5, 'edid.enum.sectorAgg.publicWaterSupply','#88CCEE');

    constructor(code,key,colour) {
        super(code,key);
        this.colour = colour;
    }

    getColour(){
        return this.colour;
    }

    static getForCode(code) {
        return Enum._getForCode(EDIDSystemAggregatorEnum, code);
    }

    static exists(code) {
        return Enum._exists(EDIDSystemAggregatorEnum, code);
    }

    static getPossibleCodes() {
        return Enum._getPossibleCodes(EDIDSystemAggregatorEnum)
    }

    static getPossibleValues() {
        return Enum._getPossibleValues(EDIDSystemAggregatorEnum)
    }
}

/**
 * Sectors
 * @extends LocalizedEnum
 * @hideconstructor
 */
class EDIDSystemEnum extends LocalizedEnum {
    static AGRICULTURE_ANNUAL_CROPS = new EDIDSystemEnum(1, EDIDSystemAggregatorEnum.AGRICULTURE, 'edid.enum.sector.agricultureAnnualCrops');
    static AGRICULTURE_PERMANENT_CROPS = new EDIDSystemEnum(6, EDIDSystemAggregatorEnum.AGRICULTURE, 'edid.enum.sector.agriculturePermanentCrops');
    static AGRICULTURE_LIVESTOCK = new EDIDSystemEnum(2, EDIDSystemAggregatorEnum.AGRICULTURE, 'edid.enum.sector.agricultureLivestock');
    static ECOSYSTEMS_AQUATIC = new EDIDSystemEnum(3, EDIDSystemAggregatorEnum.ECOSYSTEMS, 'edid.enum.sector.ecosystemsAquatic');
    static ECOSYSTEMS_TERRESTRIAL = new EDIDSystemEnum(4, EDIDSystemAggregatorEnum.ECOSYSTEMS, 'edid.enum.sector.ecosystemsTerrestrial');
    static ENERGY_HYDROPOWER = new EDIDSystemEnum(8, EDIDSystemAggregatorEnum.ENERGY, 'edid.enum.sector.energyHydropower');
    static ENERGY_TERMAL = new EDIDSystemEnum(9, EDIDSystemAggregatorEnum.ENERGY, 'edid.enum.sector.energyThermal');
    static INLAND_NAVIGATION = new EDIDSystemEnum(7, EDIDSystemAggregatorEnum.INLAND_NAVIGATION, 'edid.enum.sector.inlandNavigation');
    static PUBLIC_WATER_SUPPLY = new EDIDSystemEnum(5, EDIDSystemAggregatorEnum.PUBLIC_WATER_SUPPLY, 'edid.enum.sector.publicWaterSupply');

    constructor(code, aggregator, localizationKey) {
        super(code, localizationKey);
        this.aggregator = aggregator;
    }

    getAggregator() {
        return this.aggregator;
    }

    static getForAggregator(agg) {
        return EDIDSystemEnum.getPossibleCodes().filter(e => e.getAggregator() === agg);
    }

    static getForCode(code) {
        return Enum._getForCode(EDIDSystemEnum, code);
    }

    static exists(code) {
        return Enum._exists(EDIDSystemEnum, code);
    }

    static getPossibleCodes() {
        return Enum._getPossibleCodes(EDIDSystemEnum)
    }

    static getPossibleValues() {
        return Enum._getPossibleValues(EDIDSystemEnum)
    }
}

export {EDIDSystemEnum, EDIDSystemAggregatorEnum}